// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { RolesInstance } from "./helpers/rolesInstanceHelpers";
import { createRolesInstance } from "./helpers/rolesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseAdmin, RolesInstance>({
	name: "Roles",
	createBase: createBaseAdmin,
	createInstance: createRolesInstance,
});

export function getRolesInstance(): RolesInstance {
	return factory.getInstance();
}
